function Contact() {
  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Form submitted! (Placeholder - integrate with a backend service.)');
    e.target.reset();
  };

  return (
    <section className="py-16 pt-24 bg-gray-50 min-h-screen">
      <div className="container mx-auto px-4">
        <h1 className="text-4xl font-bold text-navy text-center mb-12 animate-fade-in">Contact Us</h1>
        <div className="max-w-lg mx-auto bg-white p-8 rounded-lg shadow-lg">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="name" className="block text-gray-600 font-semibold mb-2">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-navy"
                required
              />
            </div>
            <div>
              <label htmlFor="email" className="block text-gray-600 font-semibold mb-2">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-navy"
                required
              />
            </div>
            <div>
              <label htmlFor="message" className="block text-gray-600 font-semibold mb-2">Message</label>
              <textarea
                id="message"
                name="message"
                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-navy"
                rows="5"
                required
              ></textarea>
            </div>
            <button
              type="submit"
              className="w-full bg-navy text-white px-6 py-3 rounded-full font-semibold hover:bg-blue-900 transition-colors"
            >
              Send Message
            </button>
          </form>
          <div className="mt-8 text-center text-gray-600">
            <p>Email: <a href="mailto:info@exocontracting.com" className="hover:text-gold">info@exocontracting.com</a></p>
            <p>Phone: (123) 456-7890</p>
            <p>Address: 123 Industrial Way, City, State 12345</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;